<script>
    import { onMount } from "svelte";
    import LPButtons from "./LPButtons.svelte";
    import WPNCloseButton from "../Misc/WPNCloseButton.svelte";
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
    export let searchText = null;
    export let lpTitle;
    export let actions = [];
    export let matchCount = 0;
    export let totalCount = 0;
    export let showSearch;
    export let willShowBackButton = false;
    let txtFilterTable;
    let matchesDescription;

    $: matchesDescription = makeMatchesDescription(matchCount, totalCount);

    onMount(() => {
        if (showSearch) {
            txtFilterTable.addEventListener("keypress", function (event) {
                var arg = event.key == "Enter" ? null : event.key;
                getSearchText(arg);
            });
            txtFilterTable.addEventListener("keydown", function (event) {
                if (event.key === "Backspace") {
                    const selectionCount = event.currentTarget.selectionEnd - event.currentTarget.selectionStart;
                    if (selectionCount == event.currentTarget.value.length) {
                        event.currentTarget.value = "";
                        dispatch("search-text", { sText: "" });
                    } else if (event.currentTarget.value.length > 0) {
                        getSearchText(event.key);
                    }
                }
            });
            setSearchBox();
        }
    });

    function setSearchBox() {
        if (txtFilterTable != undefined) {
            txtFilterTable.value = searchText;
        }
        return true;
    }

    function makeMatchesDescription(numMatches, numTotal) {
        return "(".concat(numMatches.toString()).concat(" of ".concat(numTotal.toString()).concat(")"));
    }

    function getSearchText(keyValue) {
        var sText = txtFilterTable.value;
        if (keyValue === "Backspace") {
            sText = sText.slice(0, sText.length - 1);
        } else if (keyValue != null) {
            sText = sText + keyValue;
        }
        dispatch("search-text", { sText: sText });
    }
</script>

<div class="left-panel-title">
    <!-- 1. Table title -->
    {#if willShowBackButton}
        <a href={"#"} class="back-button" on:click={() => dispatch("back")}
            >&#10094;</a
        >
    {/if}
    <h4>{lpTitle}</h4>
    {#if actions.length > 0}
        <LPButtons
            {actions}
            on:print
            on:drag-on-map
            on:find-on-map
            on:edit
        />
    {/if}
    {#if showSearch}
        <div id="search-box">
            <!-- 2. Search -->
            <input
                id="txt-filter-table"
                type="text"
                bind:this={txtFilterTable}
                placeholder={"Search table"}
            />
            <input
                id="btn-filter-table"
                type="image"
                src="images/search.svg"
                alt="Search table"
                on:click={() => dispatch("search-text", { sText: txtFilterTable.value })}
            />
            <!-- 3. Matches -->
            <div id="match-box">
                {matchesDescription}
            </div>
        </div>
    {/if}
    <!-- 4. Close -->
    <WPNCloseButton on:close={() => dispatch("close-search-table")} />
</div>

<style>
    .left-panel-title {
        background-color: rgb(240, 240, 240);
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        border-bottom: 0.25px solid lightgray;
    }
    h4 {
        color: rgb(67, 148, 11);
        font-size: 1rem;
        font-weight: 300;
        margin: 16px;
    }
    #search-box {
        margin: auto;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        padding-right: 32px;
    }
    #txt-filter-table, #btn-filter-table {
        margin: 0.25rem 0;
        height: 1.8rem;
    }
    #match-box {
        padding-left: 8px;
    }
    .back-button {
        cursor: pointer;
        padding-left: 16px;
        color: darkgray;
        font-size: 24px;
        transition: 0.6s ease;
        user-select: none;
    }
    .back-button:hover {
        color: gray;
    }
</style>
